.grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    row-gap: 4px;
    width: 100%;
}

.container {
    composes: grid;
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    grid-column: 1 / 3;
}

.textfield {
    border-left: 1px solid var(--off-white-dk);
}
